// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-container {
  background-color: #F0F4F5;
  text-align: center;
  z-index: 1;
}
.pdf-container .size-control {
  position: fixed;
  top: 12rem;
  right: 1.25rem;
}
.pdf-container .size-control button {
  background: #fff;
  color: #212121;
  border-radius: 50%;
  width: 3.125rem;
  height: 3.125rem;
  border: 0;
  padding: 1rem;
  font-weight: 700;
  font-size: 1rem;
  margin: 0.5rem;
  text-align: center;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  display: block;
  z-index: 1234567890;
}
.pdf-container .size-control button:hover {
  background-color: whitesmoke;
}
.pdf-container .size-control button:active {
  background-color: #ebebeb;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.1);
}
.pdf-container .react-pdf__Document ul,
.pdf-container .react-pdf__Document li {
  list-style: none;
  padding: 0;
}
.pdf-container .react-pdf__Page {
  display: flex;
  align-items: center;
  justify-content: center;
}
.pdf-container .react-pdf__Page canvas {
  box-shadow: 5px 3px 3px rgba(0, 0, 0, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/components/PdfViewer/PdfViewer.scss","webpack://./src/style/Variables.module.scss"],"names":[],"mappings":"AAEA;EACE,yBCW4C;EDV5C,kBAAA;EACA,UAAA;AAGF;AADE;EACE,eAAA;EACA,UCFe;EDGf,cAAA;AAGJ;AAFI;EACE,gBCQQ;EDPR,cCGQ;EDFR,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,0CAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAIN;AAFM;EACE,4BAAA;AAIR;AADM;EACE,yBAAA;EACA,0CAAA;AAGR;AAGI;;EAEE,gBAAA;EACA,UAAA;AADN;AAKE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAHJ;AAKI;EACE,0CAAA;AAHN","sourcesContent":["@import \"../../../src/style/Variables.module.scss\";\n\n.pdf-container {\n  background-color: $theme-background-color-attachment-container;\n  text-align: center;\n  z-index: 1;\n\n  .size-control {\n    position: fixed;\n    top: $size-buttons-top;\n    right: 1.25rem;\n    button {\n      background: $white-color;\n      color: $black-color;\n      border-radius: 50%;\n      width: 3.125rem;\n      height: 3.125rem;\n      border: 0;\n      padding: 1rem;\n      font-weight: 700;\n      font-size: 1rem;\n      margin: 0.5rem;\n      text-align: center;\n      box-shadow: 2px 2px 3px rgba(#000, 0.3);\n      cursor: pointer;\n      display: block;\n      z-index: 1234567890;\n\n      &:hover {\n        background-color: darken($white-color, 4%);\n      }\n\n      &:active {\n        background-color: darken($white-color, 8%);\n        box-shadow: 2px 2px 3px rgba(#000, 0.1);\n      }\n    }\n  }\n\n  .react-pdf__Document {\n    ul,\n    li {\n      list-style: none;\n      padding: 0;\n    }\n  }\n\n  .react-pdf__Page {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    canvas {\n      box-shadow: 5px 3px 3px rgba(#000, 0.3);\n    }\n  }\n}\n","$light-grey-background: rgb(242, 246, 249);\n$dark-grey-background: rgb(204, 204, 204);\n\n$header-height: 5.125rem;\n$tabpanel-height: 4.5rem;\n$tabpanel-button-height: 3.5rem;\n$main-area-top-padding: 8.625rem;\n$size-buttons-top: 12rem;\n$main-area-height: calc(100vh - 8.625rem);\n\n// Colors\n$theme-primary-color: #00696B;\n$theme-secondary-color: #21decc; //#035a57\n$theme-background-color: #F0F4F5;\n$theme-background-color-attachment-container: #F0F4F5;\n\n$black-color: #212121;\n$dark-grey-color: #666;\n$medium-grey-color: #9e9e9e;\n$light-grey-color: #d8d8d8;\n$white-color: #fff;\n\n$alert-danger: #f6423c;\n$alert-warning: #facc00;\n$alert-success: #156631;\n$alert-unknown: grey;\n\n$modal-card-title-color: #005457;\n$risks-button: #06a8a2;\n$alert-warning: #facc00;\n$status-color-draft: #f3a01b;\n$status-color-signed: #00b03b;\n\n:export {\n  themeBgColorExpandButton: $theme-background-color;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"themeBgColorExpandButton": `#F0F4F5`
};
export default ___CSS_LOADER_EXPORT___;
